import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	iconAltText: {
		id: 'roadmap.timeline-table-kit.common.dependency.card.icon-alt-text',
		defaultMessage: '{typeName} issue type',
		description:
			'Image alt text. Describes what issue type an icon represents. Shown in an issue list next to the issue summary.',
	},
	datesOverlapWarning: {
		id: 'roadmap.timeline-table-kit.common.dependency.card.dates-overlap-warning',
		defaultMessage: 'Dates overlap',
		description:
			'Warning message text. Appears when a dependency due date is greater, that a target issue start date.',
	},
	startDateCaption: {
		id: 'roadmap.timeline-table-kit.common.dependency.card.start-date-caption',
		defaultMessage: 'Start date',
		description:
			'Start date caption text. Appears on the dependency tooltip and represents the start date of the dependee issue.',
	},
	dueDateCaption: {
		id: 'roadmap.timeline-table-kit.common.dependency.card.due-date-caption',
		defaultMessage: 'Due date',
		description:
			'Due date caption text. Appears on the dependency tooltip and represents the due date of the dependant issue.',
	},
	sprintStartDateCaption: {
		id: 'roadmap.timeline-table-kit.common.dependency.card.sprint-start-date-caption',
		defaultMessage: 'Sprint starts on',
		description:
			'Start date caption text. Appears on the dependency tooltip and represents the sprint start date of the dependee issue.',
	},
	sprintEndDateCaption: {
		id: 'roadmap.timeline-table-kit.common.dependency.card.sprint-end-date-caption',
		defaultMessage: 'Sprint ends on',
		description:
			'Due date caption text. Appears on the dependency tooltip and represents the sprint end date of the dependant issue.',
	},
	noStartDateSet: {
		id: 'roadmap.timeline-table-kit.common.dependency.card.no-start-date-set',
		defaultMessage: 'No start date set',
		description:
			'Date caption text. Appears instead of formatted date when blocker or blocked issue dates are unknown.',
	},
	noDueDateSet: {
		id: 'roadmap.timeline-table-kit.common.dependency.card.no-due-date-set',
		defaultMessage: 'No due date set',
		description:
			'Date caption text. Appears instead of formatted date when blocker or blocked issue dates are unknown.',
	},
	noSprintAssigned: {
		id: 'roadmap.timeline-table-kit.common.dependency.card.no-sprint-assigned',
		defaultMessage: 'No sprint assigned',
		description:
			'Date caption text. Appears instead of formatted date when blocker or blocked issue dates are unknown.',
	},
});
